import { rgb } from "pdf-lib";
import { computeSummary } from "./grouping";
import { tr } from "../i18n";

export function addPositionSummary(pdf, rows, regular, font, projectName) {
    const summary = computeSummary(rows);
    let sp = pdf.addPage([595, 842]);
    let y = 800;
    sp.drawText(tr("pdf_summary", { p: projectName || tr("pdf_project") }), { x: 40, y, size: 18, font, color: rgb(0.1, 0.1, 0.1) });
    y -= 30;
    sp.drawText(tr("pdf_summary_head"), { x: 40, y, size: 9, font, color: rgb(0.3, 0.3, 0.3) });
    y -= 6;
    sp.drawLine({ start: { x: 40, y }, end: { x: 555, y }, thickness: 0.8, color: rgb(0.6, 0.6, 0.6) });
    y -= 16;
    let totalQty = 0;
    let totalArea = 0;
    for (const s of summary) {
        totalQty += s.totalQty;
        totalArea += s.area;
        const line = `${s.positions.join(",")} | ${s.width ?? ""} | ${s.height ?? ""} | ${s.type} | ${s.motor} | ${s.color} | ${s.totalQty} | ${s.area.toFixed(2)}`;
        sp.drawText(line.substring(0, 110), { x: 40, y, size: 9, font: regular, color: rgb(0.15, 0.15, 0.15) });
        y -= 16;
        if (y < 60) { y = 800; sp = pdf.addPage([595, 842]); }
    }
    y -= 10;
    sp.drawLine({ start: { x: 40, y }, end: { x: 555, y }, thickness: 0.8, color: rgb(0.6, 0.6, 0.6) });
    y -= 18;
    sp.drawText(tr("pdf_summary_total", { q: totalQty, a: totalArea.toFixed(2), g: summary.length }), { x: 40, y, size: 11, font, color: rgb(0.1, 0.1, 0.1) });
}

export function downloadBytes(bytes, filename, type = "application/pdf") {
    const blob = new Blob([bytes], { type });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
}
